import { render, staticRenderFns } from "./LeadReassignDialog.vue?vue&type=template&id=4e6947f7&scoped=true"
import script from "./LeadReassignDialog.vue?vue&type=script&lang=ts"
export * from "./LeadReassignDialog.vue?vue&type=script&lang=ts"
import style0 from "./LeadReassignDialog.vue?vue&type=style&index=0&id=4e6947f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6947f7",
  null
  
)

export default component.exports